/**
 * A resort location at which a location-restricted entitlement is valid.
 */
export interface LiftAccessLocation {
  locationId: number;
  resortGateIdentifier: string | null;
  description: string | null;
}


/** Display text for a location. Empty when it has nothing to show, so callers can drop it from a list. */
export const locationDisplayName = (location: LiftAccessLocation): string =>
  location.description?.trim() || location.resortGateIdentifier?.trim() || '';


/**
 * The set of resort locations at which a lift entitlement is valid, as returned by the
 * `/liftaccess/{resortAbbreviation}/valid-locations` endpoint. There is one of these per requested
 * entitlement type id. When `isLocationRestricted` is false, the entitlement is valid resort-wide and
 * `validLocations` is empty.
 */
export interface LiftAccessValidLocations {
  entitlementTypeId: number;
  resortAbbreviation: string;
  isLocationRestricted: boolean;
  validLocations: LiftAccessLocation[];
}


/**
 * A cached result for a single resort + entitlement type. Carries a status so consumers can tell apart
 * "loaded" (data present, possibly empty) from "error" (the request failed). Absence from the cache means
 * the locations haven't been fetched yet (i.e. still loading / not requested).
 */
export type LiftAccessValidLocationsEntry =
  | { status: 'loaded'; data: LiftAccessValidLocations }
  | { status: 'error' };
